import IconContainer from '@/components/IconContainer'

export default function IconForward(props) {
  return (
    <IconContainer
      {...props}
      width="16"
      height="16"
      ariaLabel="Forward Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M5.13666 14.0303C4.84377 13.7374 4.84377 13.2626 5.13666 12.9697L10.2632 7.84315L5.13666 2.71663C4.84377 2.42374 4.84377 1.94886 5.13666 1.65597C5.42956 1.36308 5.90443 1.36308 6.19732 1.65597L12.3845 7.84315L6.19732 14.0303C5.90443 14.3232 5.42956 14.3232 5.13666 14.0303Z" />
    </IconContainer>
  )
}
